(function () {
  'use strict';

  var cfg = window.ZF || { routes: { root: '/', cartAdd: '/cart/add.js', cartChange: '/cart/change.js' } };
  var search = document.getElementById('searchOverlay');
  var cart = document.getElementById('cartDrawer');
  var backdrop = document.getElementById('cartBackdrop');
  var lastFocus = null;

  /* ---------- search overlay ---------- */
  function setSearchOpen(open) {
    if (!search) return;
    search.classList.toggle('is-open', open);
    if (open) {
      lastFocus = document.activeElement;
      var input = document.getElementById('searchInput');
      if (input) input.focus();
    } else {
      if (typeof clearPredictive === 'function') clearPredictive();
      if (lastFocus) {
        lastFocus.focus();
        lastFocus = null;
      }
    }
  }

  /* ---------- predictive search ---------- */
  var searchInput = document.getElementById('searchInput');
  var searchResults = document.getElementById('predictiveResults');
  var searchStatus = document.getElementById('predictiveStatus');
  var searchTimer = null;
  var searchSeq = 0;

  function money(value) {
    var locale = (cfg.language && cfg.language.iso_code) || document.documentElement.lang || undefined;
    var currency = cfg.currency || 'EUR';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(value);
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function str(key, fallback) {
    return (cfg.strings && cfg.strings[key]) || fallback;
  }

  function predictUrl(query) {
    var root = cfg.routes.root || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6';
  }

  function clearPredictive() {
    if (searchResults) {
      searchResults.innerHTML = '';
      searchResults.hidden = true;
    }
    if (searchStatus) searchStatus.textContent = '';
    if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
  }

  function imgSrc(p) {
    var img = p.featured_image;
    if (img && typeof img === 'object' && img.url) return img.url;
    if (typeof p.image === 'string' && p.image) return p.image;
    if (img && typeof img === 'string') return img;
    return '';
  }

  function imgAlt(p) {
    var img = p.featured_image;
    if (img && typeof img === 'object' && img.alt) return img.alt;
    return '';
  }

  function renderPredictive(products) {
    if (!searchResults) return;

    if (!products.length) {
      searchResults.innerHTML = '<li class="predictive__empty">' +
        str('searchEmpty', 'No products found') + '</li>';
      searchResults.hidden = false;
      if (searchStatus) searchStatus.textContent = '';
      return;
    }

    searchResults.innerHTML = products.map(function (p) {
      var src = imgSrc(p);
      var alt = imgAlt(p);
      var price = '';
      if (p.price !== undefined && p.price !== null) {
        price = '<span class="predictive__price">' + money(p.price) + '</span>';
      }
      return '<li class="predictive__item"><a href="' + esc(p.url) + '">' +
        (src
          ? '<img src="' + esc(src) + '" alt="' + esc(alt) + '" width="56" height="56" loading="lazy">'
          : '<span class="predictive__thumb" aria-hidden="true"></span>') +
        '<span class="predictive__title">' + esc(p.title) + '</span>' + price +
        '</a></li>';
    }).join('');

    searchResults.hidden = false;
    if (searchStatus) {
      searchStatus.textContent = str('searchCount', '{{ count }} results')
        .replace('{{ count }}', products.length);
    }
  }

  function runPredictive(query) {
    var seq = ++searchSeq;
    fetch(predictUrl(query), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (seq !== searchSeq) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderPredictive(products);
      })
      .catch(function () {
        if (seq === searchSeq) clearPredictive();
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (query.length < 2) {
        clearPredictive();
        return;
      }
      searchTimer = setTimeout(function () { runPredictive(query); }, 280);
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !searchResults || searchResults.hidden) return;
      clearPredictive();
      searchInput.focus();
    });

    document.addEventListener('click', function (e) {
      if (!searchResults || searchResults.hidden) return;
      if (!e.target.closest || !e.target.closest('#searchOverlay')) clearPredictive();
    });
  }

  /* ---------- section sliders ---------- */
  function initSlider(root) {
    var track = root.querySelector('[data-slider-track]');
    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    if (!track || !prev || !next) return;

    function step() {
      var first = track.querySelector('.slider__item');
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return first.getBoundingClientRect().width + (gap || 0);
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= max - 1;
      prev.disabled = atStart;
      next.disabled = atEnd || max <= 1;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      if (track._raf) return;
      track._raf = requestAnimationFrame(function () {
        track._raf = null;
        sync();
      });
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(track);
    }
    window.addEventListener('resize', sync);
    sync();

    /* ---------- optional auto-scroll ---------- */
    var autoplay = parseInt(root.getAttribute('data-slider-autoplay'), 10) || 0;
    if (!autoplay) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    var timer = null;
    var inView = true;

    function scrollable() { return track.scrollWidth - track.clientWidth > 2; }

    function advance() {
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      }
    }

    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function startAuto() {
      stopAuto();
      if (!inView || document.hidden || !scrollable()) return;
      timer = setInterval(advance, autoplay);
    }

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('focusin', stopAuto);
    root.addEventListener('focusout', startAuto);
    track.addEventListener('touchstart', function () { stopAuto(); }, { passive: true });
    track.addEventListener('touchend', function () { startAuto(); }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAuto(); else startAuto();
    });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) startAuto(); else stopAuto();
      }, { threshold: 0.2 }).observe(root);
    }

    startAuto();
  }

  document.querySelectorAll('[data-slider]').forEach(initSlider);

  /* ---------- promo banner slider ---------- */
  function initPromoSlider(root) {
    var track = root.querySelector('[data-promo-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-promo-slide]'));
    if (slides.length === 0) return;

    var prev = root.querySelector('[data-promo-prev]');
    var next = root.querySelector('[data-promo-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-promo-dot]'));
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-promo-interval'), 10) || 0;

    function go(i) {
      current = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      slides.forEach(function (el, n) { el.classList.toggle('is-active', n === current); });
      dots.forEach(function (el, n) {
        el.classList.toggle('is-active', n === current);
        el.setAttribute('aria-selected', n === current ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function play() {
      stop();
      if (!interval || reduced || slides.length < 2) return;
      timer = setInterval(function () { go(current + 1); }, interval);
    }

    if (prev) prev.addEventListener('click', function () { go(current - 1); play(); });
    if (next) next.addEventListener('click', function () { go(current + 1); play(); });
    dots.forEach(function (el) {
      el.addEventListener('click', function () { go(parseInt(el.getAttribute('data-promo-dot'), 10)); play(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(current - 1); play(); }
      if (e.key === 'ArrowRight') { go(current + 1); play(); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });

    var trackEl = track;
    var x0 = null;
    trackEl.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    trackEl.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
      x0 = null;
      play();
    }, { passive: true });

    window.addEventListener('resize', function () { go(current); });
    go(0);
    play();
  }

  document.querySelectorAll('[data-promo-slider]').forEach(initPromoSlider);

  /* ---------- cart drawer ---------- */
  function setCartOpen(open) {
    if (!cart) return;
    cart.classList.toggle('is-open', open);
    cart.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (backdrop) backdrop.classList.toggle('is-open', open);
    if (open) {
      lastFocus = document.activeElement;
      var closeBtn = cart.querySelector('.close-btn');
      if (closeBtn) closeBtn.focus();
    } else if (lastFocus) {
      lastFocus.focus();
      lastFocus = null;
    }
  }

  function setBadge(count) {
    document.querySelectorAll('[data-cart-badge]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function sectionsUrl() {
    var root = cfg.routes.root || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + '?sections=cart-drawer';
  }

  function refreshCart() {
    return fetch(sectionsUrl(), { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        var current = cart && cart.querySelector('[data-cart-inner]');
        if (!html || !current) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        if (!fresh) return;
        current.innerHTML = fresh.innerHTML;
        setBadge(parseInt(fresh.getAttribute('data-cart-count'), 10) || 0);
      });
  }

  function changeLine(line, quantity) {
    return fetch(cfg.routes.cartChange, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(refreshCart);
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-search-open]')) {
      setSearchOpen(true);
      return;
    }
    if (t.closest('[data-cart-open]')) {
      setCartOpen(true);
      return;
    }
    var closer = t.closest('[data-close]');
    if (closer) {
      var which = closer.getAttribute('data-close');
      if (which === 'search') setSearchOpen(false);
      if (which === 'cart') setCartOpen(false);
      return;
    }
    if (t === search) {
      setSearchOpen(false);
      return;
    }
    var qty = t.closest('[data-cart-qty]');
    if (qty) {
      qty.disabled = true;
      changeLine(parseInt(qty.getAttribute('data-line'), 10), parseInt(qty.getAttribute('data-quantity'), 10))
        .catch(function () { qty.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (search && search.classList.contains('is-open')) setSearchOpen(false);
    if (cart && cart.classList.contains('is-open')) setCartOpen(false);
  });

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-add]')) return;
    e.preventDefault();

    var btn = form.querySelector('[data-add-btn]');
    var err = form.querySelector('[data-form-error]');
    if (err) { err.textContent = ''; err.hidden = true; }
    if (btn) btn.disabled = true;

    fetch(cfg.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Error');
        return refreshCart().then(function () { setCartOpen(true); });
      })
      .catch(function (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
      })
      .then(function () {
        if (btn) btn.disabled = false;
      });
  });

  /* ---------- variant picker on product pages ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('[data-variant-select]')) return;
    var opt = sel.options[sel.selectedIndex];
    var form = sel.closest('form');
    var price = document.querySelector('[data-product-price]');
    var btn = form && form.querySelector('[data-add-btn]');
    if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
    if (btn) {
      var available = opt.getAttribute('data-available') === 'true';
      btn.disabled = !available;
      btn.textContent = available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
    }
  });
})();

/* ---------- article: video autoplay guard + variant price/availability ---------- */
(function () {
  'use strict';

  document.querySelectorAll('[data-article-video]').forEach(function (v) {
    // কিছু ব্রাউজার muted attribute ছাড়া property না সেট হলে autoplay block করে
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    var kick = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if (v.readyState >= 2) kick();
    else v.addEventListener('loadeddata', kick, { once: true });
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (evt) {
      document.addEventListener(evt, function once() {
        document.removeEventListener(evt, once);
        if (v.paused) kick();
      }, { once: true, passive: true });
    });
  });

  document.querySelectorAll('[data-article-variant]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var card = sel.closest('[data-article-card]');
      if (!card) return;
      var opt = sel.options[sel.selectedIndex];
      var price = card.querySelector('[data-article-price]');
      var btn = card.querySelector('[data-add-btn]');
      var label = btn && btn.getAttribute('data-label-add');
      if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      if (btn) {
        var available = opt.getAttribute('data-available') === 'true';
        btn.disabled = !available;
        if (available && label) btn.textContent = label;
      }
    });
  });
})();

/* ---------- Seven Portals: countdown + hotspot/gate state + video embed ---------- */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function remain(iso) {
    if (!iso) return null;
    var ms = new Date(iso).getTime() - Date.now();
    if (isNaN(ms) || ms <= 0) return null;
    var s = Math.floor(ms / 1000);
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }

  function isOpen(status, opens) {
    if (status === 'live') return true;
    if (!opens) return false;
    return Date.now() >= new Date(opens).getTime();
  }

  function hub() {
    var hotspots = document.querySelectorAll('[data-gate-hotspot]');
    var cards = document.querySelectorAll('[data-gate-card]');
    if (!hotspots.length && !cards.length) return;

    function paint(el, isHotspot) {
      var status = el.getAttribute('data-status');
      var opens = el.getAttribute('data-opens');
      var open = isOpen(status, opens);
      el.classList.toggle('is-live', open);
      el.classList.toggle('is-locked', !open);
      if (isHotspot) return;
      var state = el.querySelector('[data-gate-state]');
      var enter = el.querySelector('[data-gate-enter]');
      var mini = el.querySelector('[data-gate-mini]');
      if (state) state.textContent = open ? 'Live' : 'Locked';
      if (enter) enter.textContent = open ? 'Enter' : 'Coming soon';
      if (mini) {
        if (!open && opens) {
          var r = remain(opens);
          mini.textContent = r ? (r.d + 'g ' + pad(r.h) + ':' + pad(r.m) + ':' + pad(r.s)) : '';
        } else {
          mini.textContent = '';
        }
      }
    }

    function tick() {
      hotspots.forEach(function (el) { paint(el, true); });
      cards.forEach(function (el) { paint(el, false); });
    }
    tick();
    setInterval(tick, 1000);
  }

  function teaser() {
    var root = document.querySelector('[data-portal-teaser]');
    if (!root) return;
    var opens = root.getAttribute('data-opens');
    if (!opens) return;
    function tick() {
      var r = remain(opens);
      if (!r) {
        root.classList.add('is-open');
        return;
      }
      var d = root.querySelector('[data-d]'), h = root.querySelector('[data-h]');
      var m = root.querySelector('[data-m]'), s = root.querySelector('[data-s]');
      if (d) d.textContent = pad(r.d);
      if (h) h.textContent = pad(r.h);
      if (m) m.textContent = pad(r.m);
      if (s) s.textContent = pad(r.s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function embed() {
    document.querySelectorAll('[data-portal-embed]').forEach(function (box) {
      var src = (box.getAttribute('data-portal-embed') || '').trim();
      if (!src) return;
      var poster = box.getAttribute('data-portal-poster') || '';
      var yt = src.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([A-Za-z0-9_-]{6,})/);
      var vm = src.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      var html;
      if (yt) {
        html = '<iframe src="https://www.youtube.com/embed/' + yt[1] + '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      } else if (vm) {
        html = '<iframe src="https://player.vimeo.com/video/' + vm[1] + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      } else {
        html = '<video controls playsinline preload="metadata"' + (poster ? ' poster="' + poster + '"' : '') + '><source src="' + src + '" type="video/mp4"></video>';
      }
      box.innerHTML = html;
    });
  }

  function carousel() {
    var roots = document.querySelectorAll('[data-gates-carousel]');
    if (!roots.length) return;

    roots.forEach(function (vp) {
      var track = vp.querySelector('.gates__track');
      if (!track) return;
      var cards = track.querySelectorAll('.gate');
      if (cards.length < 2) return;

      var section = vp.closest('.gates-section') || document;
      var prevBtn = section.querySelector('[data-gates-prev]');
      var nextBtn = section.querySelector('[data-gates-next]');

      var idx = 0;
      var timer = null;
      var raf = 0;
      var DELAY = 3800;

      function gap() {
        var cs = getComputedStyle(track);
        return parseFloat(cs.columnGap || cs.gap) || 0;
      }
      function step() { return cards[0].getBoundingClientRect().width + gap(); }
      function perView() {
        var s = step();
        return s > 0 ? Math.max(1, Math.round((vp.clientWidth + gap()) / s)) : 1;
      }
      function maxIdx() { return Math.max(0, cards.length - perView()); }
      function go(i) {
        idx = i;
        vp.scrollTo({ left: idx * step(), behavior: 'smooth' });
      }
      function advance() {
        var m = maxIdx();
        if (m <= 0) return;
        go(idx >= m ? 0 : idx + 1);
      }
      function start() { if (!timer && maxIdx() > 0) timer = setInterval(advance, DELAY); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function sync() { var s = step(); if (s > 0) idx = Math.round(vp.scrollLeft / s); }

      vp.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; sync(); });
      });
      vp.addEventListener('mouseenter', stop);
      vp.addEventListener('mouseleave', start);
      vp.addEventListener('touchstart', stop, { passive: true });
      vp.addEventListener('touchend', function () { setTimeout(start, 6000); }, { passive: true });
      window.addEventListener('resize', function () { go(Math.min(idx, maxIdx())); });
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

      if (prevBtn) prevBtn.addEventListener('click', function () {
        stop();
        go(idx <= 0 ? maxIdx() : idx - 1);
        start();
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        stop();
        advance();
        start();
      });

      start();
    });
  }

  hub();
  teaser();
  embed();
  carousel();
})();

/* ---------- PDP gallery: thumbnails, hover zoom, lightbox, quantity ---------- */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var frame = document.getElementById('pdpZoom');
    var main = document.getElementById('pdpMain');
    if (!frame || !main) return;

    var light = document.getElementById('pdpLightbox');
    var lightImg = document.getElementById('pdpLightboxImg');

document.querySelectorAll('.pdp-thumbs button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          document.querySelectorAll('.pdp-thumbs button').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var src = btn.getAttribute('data-src');
          main.src = src;
          var w = btn.getAttribute('data-w');
          var h = btn.getAttribute('data-h');
          if (w && h) {
            main.width = w;
            main.height = h;
            if (lightImg) { lightImg.width = w; lightImg.height = h; }
          }
          if (lightImg) lightImg.src = src;
        });
      });

    frame.addEventListener('mousemove', function (e) {
      var r = frame.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      frame.classList.add('is-zoom');
      main.style.transformOrigin = x + '% ' + y + '%';
    });
    frame.addEventListener('mouseleave', function () {
      frame.classList.remove('is-zoom');
      main.style.transformOrigin = 'center center';
    });

    if (light && lightImg) {
      frame.addEventListener('click', function () {
        lightImg.src = main.src;
        light.classList.add('is-open');
        light.setAttribute('aria-hidden', 'false');
      });
      function closeZoom() {
        light.classList.remove('is-open');
        light.setAttribute('aria-hidden', 'true');
      }
      var closeBtn = document.getElementById('closeZoom');
      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); closeZoom(); });
      light.addEventListener('click', closeZoom);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    }

    var qty = document.getElementById('qtyInput');
    var minus = document.getElementById('qtyMinus');
    var plus = document.getElementById('qtyPlus');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      });
      plus.addEventListener('click', function () {
        qty.value = Math.min(99, (parseInt(qty.value, 10) || 1) + 1);
      });
    }
  });
})();

/* Age verification pop-up. Acceptance is remembered for the browser session
   only (sessionStorage), so the gate comes back on the next session. The
   already-accepted case is handled before first paint by the inline script in
   the layout; here we only finish the job for the deferred case and wire the
   buttons. */
(function () {
  var gate = document.getElementById('AgeGate');
  if (!gate) return;

  var key = gate.getAttribute('data-storage-key') || 'age_gate_ok';
  var confirm = gate.querySelector('[data-age-accept]');
  var reject = gate.querySelector('[data-age-reject]');
  var rejected = gate.querySelector('[data-age-rejected]');

  function lock(on) {
    document.documentElement.classList.toggle('age-gate-locked', on);
  }

  function dismiss() {
    gate.setAttribute('hidden', '');
    lock(false);
  }

  function accepted() {
    try { window.sessionStorage.setItem(key, '1'); } catch (e) {}
    dismiss();
  }

  function refused() {
    try { window.sessionStorage.setItem(key, '0'); } catch (e) {}
    if (rejected) rejected.removeAttribute('hidden');
    if (confirm) confirm.setAttribute('hidden', '');
    if (reject) reject.setAttribute('hidden', '');
    lock(true);
  }

  if (confirm) confirm.addEventListener('click', accepted);
  if (reject) reject.addEventListener('click', refused);

  var alreadyOk = false;
  try { alreadyOk = window.sessionStorage.getItem(key) === '1'; } catch (e) {}
  if (alreadyOk || document.documentElement.classList.contains('age-gate-ok')) {
    dismiss();
  } else {
    lock(true);
  }

  if (confirm) confirm.focus();
})();

/* The store's age-verification app embed is disabled on the live theme; on
   this theme it is on and its popup (z-index 50, injected with inline
   !important styles) covers the header icons on every page — while the
   theme's own gate (rendered on the home page only, like the live theme)
   handles verification. Keep the app popup hidden everywhere, even when the
   app injects it after this script has run. */
(function hideAppAgeGate() {
  /* The app also locks page scroll by writing an inline
     `position: fixed; overflow: hidden !important` on <body>. Since we hide
     its popup, that lock must be cleared too or the whole page (storefront
     and theme editor) stays frozen at scrollY 0. */
  function unlockBody() {
    var b = document.body;
    if (!b) return;
    b.style.removeProperty('overflow');
    b.style.removeProperty('position');
    b.style.removeProperty('top');
    b.style.removeProperty('left');
    b.style.removeProperty('width');
    document.documentElement.style.removeProperty('overflow');
  }
  function watch(node) {
    try {
      new MutationObserver(hide).observe(node, { attributes: true, attributeFilter: ['style', 'class'] });
    } catch (e) {}
  }
  function hide() {
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('pointer-events', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
    unlockBody();
  }
  var node = document.getElementById('popup-model');
  if (node) { hide(); watch(node); }
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          var t = n.id === 'popup-model' ? n : (n.querySelector ? n.querySelector('#popup-model') : null);
          if (t && t !== node) { node = t; hide(); watch(t); }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  /* The app can re-apply the body lock after we clear it; keep watching. */
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var b = muts[i].target;
        if (b.nodeType === 1 && b.style && b.style.position === 'fixed' && b.style.overflow === 'hidden') {
          unlockBody();
        }
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
  } catch (e) {}
})();

/* Marketing consent: marketing tag only when the user opts in.
   The portal / intimate-preference tag is never added, so subscribers
   cannot be segmented or auto-targeted from this form. */
(function () {
  var forms = document.querySelectorAll('.mail-form');
  Array.prototype.forEach.call(forms, function (form) {
    var consent = form.querySelector('[data-mail-consent]');
    var tags = form.querySelector('[data-mail-tags]');
    if (!consent || !tags) return;
    var sync = function () {
      tags.value = consent.checked ? 'newsletter' : '';
    };
    consent.addEventListener('change', sync);
    sync();
  });
})();

/* Newsletter pop-up: trigger + mandatory consent gate */
(function () {
  var popup = document.getElementById('NewsPopup');
  if (!popup) return;

  var form = popup.querySelector('.news-popup__form');
  var consent = popup.querySelector('[data-news-consent]');
  var submit = popup.querySelector('[data-news-submit]');
  var tags = popup.querySelector('[data-news-tags]');
  var hint = popup.querySelector('[data-news-hint]');
  var email = popup.querySelector('.news-popup__email');
  var close = popup.querySelector('[data-news-close]');
  var key = popup.getAttribute('data-storage-key') || 'news_popup_seen';

  var subscribed = !!popup.querySelector('.news-popup__done');
  var timer = null;

  function seen() {
    try { return window.localStorage.getItem(key) === '1'; } catch (e) { return false; }
  }
  function remember() {
    try { window.localStorage.setItem(key, '1'); } catch (e) {}
  }
  function open() {
    popup.removeAttribute('hidden');
    if (email) setTimeout(function () { email.focus(); }, 60);
  }
  function dismiss() {
    popup.setAttribute('hidden', '');
    remember();
    if (timer) clearTimeout(timer);
  }

  if (subscribed) {
    open();
  } else if (seen()) {
    popup.setAttribute('hidden', '');
  } else {
    timer = setTimeout(open, parseInt(popup.getAttribute('data-delay'), 10) || 12000);
  }

if (close) close.addEventListener('click', dismiss);
    popup.addEventListener('click', function (e) { if (e.target === popup) dismiss(); });

    /* Manual trigger: the envelope icon in the social row, and any other
       element carrying data-news-open. Cancels the pending auto-open timer
       so the pop-up is not immediately re-shown on the next page. */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-news-open]');
      if (!trigger) return;
      e.preventDefault();
      if (timer) clearTimeout(timer);
      open();
      if (close) close.focus();
    });

    /* Omnisend: when a Form ID is configured the form posts to Omnisend
       instead of Shopify. Omnisend answers with CORS only on its own
       endpoint, so failures are surfaced inline rather than silently
       losing the subscriber. */
    var omniForm = popup.querySelector('[data-omnisend]');
    if (omniForm) {
      var omniError = omniForm.querySelector('[data-omni-error]');
      omniForm.addEventListener('submit', function (e) {
        if (!consent || !consent.checked) {
          e.preventDefault();
          if (hint) hint.removeAttribute('hidden');
          if (consent) consent.focus();
          return;
        }
        var value = email ? email.value.trim() : '';
        if (!value || !email.checkValidity()) {
          e.preventDefault();
          if (omniError) {
            omniError.textContent = 'Please enter a valid email address.';
            omniError.removeAttribute('hidden');
          }
          if (email) email.focus();
          return;
        }
        e.preventDefault();
        if (submit) submit.disabled = true;
        if (omniError) omniError.setAttribute('hidden', '');

        fetch('https://www.omnisend.com/api/v3/forms', {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            formId: omniForm.getAttribute('data-omnisend-id'),
            email: value,
            consent: true,
            consentToProcess: true,
            location: 'footer'
          })
        })
          .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.message) || 'Subscription failed');
            var card = omniForm.parentNode;
            var done = card.querySelector('.news-popup__done');
            if (!done) {
              done = document.createElement('div');
              done.className = 'news-popup__done';
              done.innerHTML = '<p class="news-popup__badge">&#10003;</p>' +
                '<h2 class="news-popup__title" id="NewsPopupTitle">You are subscribed</h2>' +
                '<p class="news-popup__text">Check your inbox to confirm your email address.</p>';
            }
            omniForm.replaceWith(done);
            remember();
          })
          .catch(function (ex) {
            if (omniError) {
              omniError.textContent = ex.message || 'Something went wrong. Please try again.';
              omniError.removeAttribute('hidden');
            }
            if (submit) submit.disabled = false;
          });
      });
    }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hasAttribute('hidden')) dismiss();
  });

  /* Mandatory consent: the button stays disabled until the box is ticked. */
  function syncConsent() {
    var ok = !!(consent && consent.checked);
    if (submit) submit.disabled = !ok;
    if (tags) tags.value = ok ? 'newsletter' : '';
    if (hint) hint.setAttribute('hidden', 'true');
  }
  if (consent) {
    consent.addEventListener('change', syncConsent);
    syncConsent();
  }

  /* Safety net: pressing Enter inside the email field submits the form
     without ticking the box, so the consent is enforced here too. */
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!consent || !consent.checked) {
        e.preventDefault();
        if (hint) hint.removeAttribute('hidden');
        if (consent) consent.focus();
      }
    });
  }
})();

/* Intro statement: smooth-scroll the "scroll & discover the collections"
   link down to the first collection showcase below it (works regardless of
   how the sections are ordered in the template). */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-scroll-collections]');
    if (!link) return;
    var origin = link.closest('section');
    var showcases = document.querySelectorAll('.collection-showcase');
    var target = null;
    for (var i = 0; i < showcases.length; i++) {
      if (!origin || (origin.compareDocumentPosition(showcases[i]) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        target = showcases[i];
        break;
      }
    }
    if (!target) target = document.querySelector('#collezioni');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (target.id && window.history && history.replaceState) {
      history.replaceState(null, '', '#' + target.id);
    }
  });
})();

/* Inline Omnisend forms (article page and anywhere else): same endpoint as
   the pop-up, bound per-form so multiple signups can coexist on one page. */
(function () {
  var forms = document.querySelectorAll('form[data-omnisend]');
  for (var i = 0; i < forms.length; i++) {
    (function (omniForm) {
      var errEl = omniForm.querySelector('[data-omni-error]');
      var miniConsent = omniForm.querySelector('[data-news-consent]');
      var miniHint = omniForm.querySelector('[data-news-hint]');
      var miniEmail = omniForm.querySelector('input[type="email"]');
      var miniSubmit = omniForm.querySelector('button[type="submit"]');
      var doneClass = omniForm.getAttribute('data-omni-done-class') || 'mail-form is-done';

      if (miniConsent) {
        miniConsent.addEventListener('change', function () {
          if (miniSubmit) miniSubmit.disabled = !miniConsent.checked;
          if (miniHint) miniHint.setAttribute('hidden', '');
        });
        if (miniSubmit) miniSubmit.disabled = !miniConsent.checked;
      }

      omniForm.addEventListener('submit', function (e) {
        if (miniConsent && !miniConsent.checked) {
          e.preventDefault();
          if (miniHint) miniHint.removeAttribute('hidden');
          if (miniConsent) miniConsent.focus();
          return;
        }
        var value = miniEmail ? miniEmail.value.trim() : '';
        if (!value || (miniEmail && !miniEmail.checkValidity())) {
          e.preventDefault();
          if (errEl) {
            errEl.textContent = 'Please enter a valid email address.';
            errEl.removeAttribute('hidden');
          }
          if (miniEmail) miniEmail.focus();
          return;
        }
        e.preventDefault();
        if (miniSubmit) miniSubmit.disabled = true;
        if (errEl) errEl.setAttribute('hidden', '');

        fetch('https://www.omnisend.com/api/v3/forms', {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            formId: omniForm.getAttribute('data-omnisend-id'),
            email: value,
            consent: true,
            consentToProcess: true,
            location: omniForm.getAttribute('data-omnisend-location') || 'blog'
          })
        })
          .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && res.body.message) || 'Subscription failed');
            var done = document.createElement('div');
            done.className = doneClass;
            done.textContent = omniForm.getAttribute('data-omni-done-text') || 'Grazie. Riceverai le nostre comunicazioni.';
            omniForm.replaceWith(done);
          })
          .catch(function (ex) {
            if (errEl) {
              errEl.textContent = ex.message || 'Something went wrong. Please try again.';
              errEl.removeAttribute('hidden');
            }
            if (miniSubmit) miniSubmit.disabled = false;
          });
      });
    })(forms[i]);
  }
})();

/* ---------- read more / read less (review cards + showcase cards) ---------- */
(function () {
  function initReadMore(cardSel, textSel, toggleSel) {
    var cards = document.querySelectorAll(cardSel);
    if (!cards.length) return;

    document.documentElement.classList.add('review-js');

    function isOverflowing(el) {
      return el.scrollHeight - el.clientHeight > 2;
    }

    function refresh(card) {
      var text = card.querySelector(textSel);
      var toggle = card.querySelector(toggleSel);
      if (!text || !toggle) return;
      if (card.classList.contains('is-expanded')) {
        toggle.hidden = false;
        return;
      }
      toggle.hidden = !isOverflowing(text);
    }

    function refreshAll() {
      Array.prototype.forEach.call(document.querySelectorAll(cardSel), refresh);
    }

    Array.prototype.forEach.call(cards, function (card) {
      var toggle = card.querySelector(toggleSel);
      if (!toggle) return;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded = card.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? toggle.getAttribute('data-less') : toggle.getAttribute('data-more');
        refresh(card);
      });

      refresh(card);
    });

    var raf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(refreshAll);
    });
    window.addEventListener('load', refreshAll);
  }

  initReadMore('.review-card', '.review-card__quote', '.review-card__toggle');
  initReadMore('.card', '.card__text', '.card__toggle');
})();

